// @flow
import { styled } from 'mz-ui-kit'

export const SelectorsList = styled('div', {
  display: 'flex',
  flexGrow: 1,
  padding: '20px 40px',
  alignItems: 'center',
  justifyContent: 'space-around',
})

export const Container = styled('div', {
  minWidth: '250px',
})

export const ColonSeparator = styled('div', {
  ':before': {
    content: '":"',
    fontSize: '20px',
    fontWeight: 'bold',
  },
})
